<template src="./template.html"></template>

<script>
  import { mapActions, mapGetters, mapState } from 'vuex'
  import { mapFields } from 'vuex-map-fields'
  import CartAddressFields from '../CartAddressFields'
  import CartAddressHeader from '../CartAddressHeader'

  export default {
    name: 'CartAddress',
    components: {
      CartAddressFields,
      CartAddressHeader,
    },
    props: {
      index: Number,
      invalid: Boolean,
      isTabActive: Boolean,
      showAddress: Boolean,
      tabs: Array,
      validated: Boolean,
    },
    computed: {
      ...mapGetters('cart', ['isPending']),
      ...mapState('cart', [
        'isGuest',
        'cartRequiredFields',
      ]),
      ...mapState('invoiceAddress', ['has_newsletter']),
      ...mapFields('invoiceAddress', ['newsletter']),
      isDeliveryAddressActive: {
        get() {
          return this.$store.state.deliveryAddress.deliveryAddressActive
        },
        set() {
          this.updateDeliveryAddressActive()
        },
      },
    },
    created() {
      this.getCart()
      this.$store.subscribe(mutation => {
        switch (mutation.type) {
          case 'payment/SET_ACTIVE_SERVICE':
            this.updateAddress()
            break
          default:
            return false
        }
      })
    },
    methods: {
      ...mapActions('cart', ['getCart']),
      ...mapActions('deliveryAddress', ['updateDeliveryAddressActive']),
      updateAddress() {
        // console.log('update address')
      },
    },
  }
</script>
